import { Injectable } from "@angular/core";
import { Subject } from "rxjs";

@Injectable({ providedIn: "root" })
export class HeaderService {
    private backgroundCssSubject = new Subject<string>();
    backgroundCss$ = this.backgroundCssSubject.asObservable();

    setBackgroundCss(cssClass: string): void {
        this.backgroundCssSubject.next(cssClass);
    }

    sendExitWebViewMessage(): void {
        if (!(window as any).ReactNativeWebView) {
            return;
        }

        (window as any).ReactNativeWebView.postMessage("exitWebView");
    }
}
